import { css } from "styled-components";

export const SermonContentStyle = css`
  line-height: 1.8;
  color: #444;

  h1,
  h2,
  h3 {
    font-size: 18px;
    margin: 30px 0 15px 0;
    font-weight: 700;
  }

  p {
    margin-bottom: 15px;
    text-align: justify;
  }

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  u {
    text-decoration: underline;
  }

  s {
    text-decoration: line-through;
  }

  blockquote {
    border-left: 4px solid #ccc;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
  }

  ul,
  ol {
    padding-left: 30px;
  }
`;
